import React from 'react';
import PropTypes from 'prop-types';
import tw, {styled, css} from 'twin.macro';
import {motion} from 'framer-motion';

Success.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

function Success (props) {
  const {
    children,
    ...rest
  } = props;

  return (
    <motion.div
      initial={{opacity: 0, height: 0}}
      animate={{opacity: 1, height: 'auto'}}
      transition={{duration: 0.15}}
    >
      <SuccessMessage {...rest}>{children}</SuccessMessage>
    </motion.div>
  );
}

const SuccessMessage = styled.div((props) => [
  tw`
    bg-green-500
    text-sm
    py-2
    px-2.5
    text-white
    relative
    before:border-green-500
  `,
  props.arrow && tw`
    mt-4
  `,
  props.arrow && css`
    &::before {
      bottom: 100%;
      left: 12px;
      border: solid transparent;
      content: '';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-bottom-color: hsla(162,63%,41%,var(--tw-bg-opacity));;
      border-width: 8px;
    }
  `,
]);

export default Success;
